import { combineReducers } from 'redux'
import appReducers from './appReducers'
import userReducers from './userReducers'
import challengeQuestionsReducers from './challengeQuestionsReducers'
import accountActivateReducers from './accountActivateReducers'
import userInfoReducers from './userInfoReducers'
import resetPasswordUserInfoReducers from './resetPasswordUserInfoReducers'
import changePasswordUserInfoReducers from './changePasswordUserInfoReducers'
import expiredPasswordUserInfoReducers from './expiredPasswordUserInfoReducers'
import verifyEmailReducers from './verifyEmailReducers'

const reducers = combineReducers({
  appReducers,
  userReducers,
  challengeQuestionsReducers,
  accountActivateReducers,
  userInfoReducers,
  resetPasswordUserInfoReducers,
  changePasswordUserInfoReducers,
  expiredPasswordUserInfoReducers,
  verifyEmailReducers
})


export default reducers